import React from 'react';
const createArrowPoligon = (deviation) => {
    const x = 0;
    const bottom = 20;
    const middle = 10;
    const top = 0;
    return deviation < 0 ? createArrowDown({ x, middle, top, bottom }) : createArrowTop({ x, middle, top, bottom });
};
const createArrowDown = ({ x, middle, top, bottom }) => `${x - 20},${middle} ${x - 10},${middle} ${x - 10},${top} ${x + 10},${top} ${x + 10},${middle} ${x + 20},${middle} ${x},${bottom}}`;
const createArrowTop = ({ x, middle, top, bottom }) => `${x - 20},${middle} ${x},${top} ${x + 20},${middle} ${x + 10},${middle} ${x + 10},${bottom} ${x - 10},${bottom} ${x - 10},${middle}}`;
const createTransformCoordinates = ({ x, yPositions, deviation, barWidth, }) => {
    const y = deviation > 0 ? yPositions[0] : yPositions[1];
    const arrowWidth = 40;
    const xScale = barWidth > 70 ? 1 : (Math.min(arrowWidth, barWidth) / Math.max(arrowWidth, barWidth)) * 0.8;
    return `translate(${x},${y}) scale(${xScale}, 1)`;
};
export const ChartArrow = ({ cx, deviation, yPositions, barWidth }) => {
    return (React.createElement("polygon", { points: createArrowPoligon(deviation), fill: "black", transform: createTransformCoordinates({ x: cx, yPositions, deviation, barWidth }) }));
};
//# sourceMappingURL=ChartArrow.js.map